import { useMutation } from '@tanstack/react-query'
import { IHttpError, IResponse, Model, ObjectsFactory } from '../core'

export interface ISystemMaintenance {
  message: string
  data: ISystemMaintenanceData
}

export interface ISystemMaintenanceData {
  is_maintenance: boolean
}

const modelConfig = {
  path: '/setting/system-maintenance',
  model: 'SYSTEM_MAINTENANCE'
}

export class SystemMaintenance extends Model {
  static queryKeys = {
    paginate: 'SYSTEM_MAINTENANCE_PAGINATE_QUERY',
    findOne: 'SYSTEM_MAINTENANCE_FIND_ONE_QUERY'
  }

  static objects = ObjectsFactory.factory<ISystemMaintenance>(modelConfig, this.queryKeys)

  static getSystemMaintenance() {
    return {
      queryKey: [this.queryKeys.findOne],
      queryFn: () => {
        return this.api.get<ISystemMaintenance>({ url: modelConfig.path }).then(r => r.data)
      }
    }
  }
}

SystemMaintenance.setup(modelConfig)

// mutation

export function useUpdateSystemMaintenanceMutation() {
  return useMutation<IResponse<ISystemMaintenance>, IHttpError, { is_maintenance: boolean }>({
    mutationFn: ({ is_maintenance }) => {
      return SystemMaintenance.api
        .put<IResponse<ISystemMaintenance>>({
          url: modelConfig.path,
          data: {
            is_maintenance
          }
        })
        .then(r => r.data)
    }
  })
}
